module.exports = __webpack_public_path__ + "static/media/contentcreators_header.9dd69ca4.jpg";